import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`
        }
    },
    title: {
        '&&': {
            marginBottom: 20
        }
    },
    paper: {
        '&&': {
            borderRadius: 25,
            width: 450,
            height: 650,
            '@media (max-width: 400px)':
            {
                width: '100%'
            }
        }
    },
    root: {
        '&&': {
            padding: 0
        }
    },
    container: {
        '&&': {
            backgroundColor: '#00000080'
        }
    },
    dialog: {
        cursor: 'default'
    },
    content: {
        '&&': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            backgroundColor: '#000f14',
        }
    },
    button: {
        '&&': {
            top: 10,
            color: 'white',
            backgroundColor: '#000f14A6',
            height: 40,
            width: 40,
            minWidth: 0,
            borderRadius: 15,
            '&:hover': {
                backgroundColor: '#000f14A6'
            }
        }
    },
    close: {
        '&&': {
            position: 'absolute',
            left: 10
        }
    },
    favorite: {
        right: 10
    },
    name: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            color: 'white',
            letterSpacing: 1.5,
            textAlign: 'start',
            '@media (max-width: 960px)': {
                textAlign: 'center'
            }
        }
    },
    modalButton: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            fontSize: 15,
            borderRadius: 15,
            height: 37,
            color: 'white'
        }
    },
    filled: {
        '&&': {
            backgroundColor: '#283136',
            width: 120,
            '&:hover':
            {
                backgroundColor: '#283136CC'
            }
        }
    },
    unfilled: {
        '&&': {
            width: 100,
            marginRight: 10,
            borderColor: '#283136',
            border: '2px solid #283136',
            '&:hover':
            {
                backgroundColor: 'transparent'
            }
        }
    }
});